import { create } from "zustand"

const usePrePaymentOrders = create((set) => ({
  prePaymentOrders: [],
  prePaymentOrdersCount: 0,
  loading: true,
  setPrePaymentOrders: (orders) =>
    set({
      prePaymentOrders: orders,
      prePaymentOrdersCount: orders.length,
      loading: false,
    }),
  setPrePaymentsLoading: (loadingState) => set({ loading: loadingState }),
}))

export default usePrePaymentOrders
